/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Health_FailedInputs */

const id_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemrosesan gagal`)
};

const ms_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemprosesan gagal`)
};

const da_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandling mislykkedes`)
};

const de_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verarbeitung fehlgeschlagen`)
};

const en_us2_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing failed`)
};

const es_es2_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de procesamiento`)
};

const es_mx2_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error de procesamiento`)
};

const fil_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nabigo ang pagproseso`)
};

const fr_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec du traitement`)
};

const it_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elaborazione non riuscita`)
};

const hu_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sikertelen feldolgozás`)
};

const nl_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerking mislukt`)
};

const no_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Behandlingen mislyktes`)
};

const pl_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przetwarzanie nie powiodło się`)
};

const pt_br2_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no processamento`)
};

const pt_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha no processamento`)
};

const ro_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesarea a eșuat`)
};

const fi_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Käsittely epäonnistui`)
};

const sv_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbetningen misslyckades`)
};

const vi_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xử lý thất bại`)
};

const tr_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşleme başarısız oldu`)
};

const cs_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zpracování selhalo`)
};

const bg_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обработката е неуспешна`)
};

const ru_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка обработки`)
};

const uk_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка обробки`)
};

const ar_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فشلت المعالجة`)
};

const hi_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रोसेसिंग विफल`)
};

const th_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ประมวลผลไม่สำเร็จ`)
};

const ja_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`処理に失敗`)
};

const zh_cn2_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理失败`)
};

const zh_hant1_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`處理失敗`)
};

const ko_builds_health_failed = /** @type {(inputs: Builds_Health_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`처리 실패`)
};

/**
* | output |
* | --- |
* | "Processing failed" |
*
* @param {Builds_Health_FailedInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_health_failed = /** @type {((inputs?: Builds_Health_FailedInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Health_FailedInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_health_failed(inputs)
	if (locale === "ms") return ms_builds_health_failed(inputs)
	if (locale === "da") return da_builds_health_failed(inputs)
	if (locale === "de") return de_builds_health_failed(inputs)
	if (locale === "en-US") return en_us2_builds_health_failed(inputs)
	if (locale === "es-ES") return es_es2_builds_health_failed(inputs)
	if (locale === "es-MX") return es_mx2_builds_health_failed(inputs)
	if (locale === "fil") return fil_builds_health_failed(inputs)
	if (locale === "fr") return fr_builds_health_failed(inputs)
	if (locale === "it") return it_builds_health_failed(inputs)
	if (locale === "hu") return hu_builds_health_failed(inputs)
	if (locale === "nl") return nl_builds_health_failed(inputs)
	if (locale === "no") return no_builds_health_failed(inputs)
	if (locale === "pl") return pl_builds_health_failed(inputs)
	if (locale === "pt-BR") return pt_br2_builds_health_failed(inputs)
	if (locale === "pt") return pt_builds_health_failed(inputs)
	if (locale === "ro") return ro_builds_health_failed(inputs)
	if (locale === "fi") return fi_builds_health_failed(inputs)
	if (locale === "sv") return sv_builds_health_failed(inputs)
	if (locale === "vi") return vi_builds_health_failed(inputs)
	if (locale === "tr") return tr_builds_health_failed(inputs)
	if (locale === "cs") return cs_builds_health_failed(inputs)
	if (locale === "bg") return bg_builds_health_failed(inputs)
	if (locale === "ru") return ru_builds_health_failed(inputs)
	if (locale === "uk") return uk_builds_health_failed(inputs)
	if (locale === "ar") return ar_builds_health_failed(inputs)
	if (locale === "hi") return hi_builds_health_failed(inputs)
	if (locale === "th") return th_builds_health_failed(inputs)
	if (locale === "ja") return ja_builds_health_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_health_failed(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_health_failed(inputs)
	return ko_builds_health_failed(inputs)
});
export { builds_health_failed as "builds.health.failed" }